<script setup lang="ts">
import Toast from '@/components/Toast.vue';
import { useToast } from '@/composables/useToast';

const { toasts, dismissToast } = useToast();
</script>

<template>
    <div class="toast-manager">
        <TransitionGroup name="toast" tag="div" class="toast-stack">
            <Toast
                v-for="toast in toasts"
                :key="toast.id"
                :toast="toast"
                @dismiss="dismissToast"
            />
        </TransitionGroup>
    </div>
</template>

<style scoped>
.toast-manager {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 2000;
}

.toast-stack {
    width: 100%;
}

.toast-enter-active,
.toast-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.toast-enter-from,
.toast-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}
</style>
